import React, { useContext, useEffect, useState } from "react";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";

import GeneralContext from "../../context/GeneralContext/GeneralContext";
import api from "../../services/api";
import CustomToolbar from "../../components/grid/CustomToolbar";
import SL_Button from "../../components/buttons/Button";
import {
  UserAddOutlined,
  FileSearchOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  displayMessage,
  getLanguageOnLocalstorage,
} from "../../services/helper";
import exercise_grid_columns from "./grid_columns/exercise_grid_columns";
import CreateExercise from "./CreateExercise";
import DetailExercise from "./DetailExercise";
import { Popconfirm, Select } from "antd";
import { DeleteOutline } from "@material-ui/icons";
import { CreateExerciseModal } from "./CreateExerciseModal";
import { FooterTable } from "../../components/grid/FooterTable";
import ELanguages from "../../enums/ELanguages";
export default function ListExercise() {
  const rowsPerPage = 10;
  const initialOffset = 0;
  const { setShowLoading, windowHeight, mobile_mode, enums, setEnums, user } =
    useContext(GeneralContext);

  const [loadedExrcises, setLoadedExrcises] = useState([]);
  const [currentExercise, setCurrentExercise] = useState(null);
  const [isModalCreateExerciseVisible, setIsModalCreatePatientVisible] =
    useState(false);
  const [isModalDetailExerciseVisible, setIsModalDetailPatientVisible] =
    useState(false);
  const [isModalDownloadVisible, setIsModalDownloadVisible] = useState(false);
  const [selectedDownloadRow, setSelectedDownloadRow] = useState(null);
  const [offset, setOffset] = useState(initialOffset);
  const [quantityRows, setQuantityRows] = useState(rowsPerPage);
  const [currentLanguage, setCurrentLanguage] = useState([])
  const currentLanguageCode = getLanguageOnLocalstorage();
  const gridRef = useGridApiRef();
  const DataGridProHeight = windowHeight * 0.7;
  const { Option } = Select;

  useEffect(() => {
    if (!enums) {
      setShowLoading(true);
      api.auth.getEnums().then((rs) => {
        setEnums(rs.data);
        setShowLoading(false);
      });
    }
    const lang = Object.values(ELanguages).find(
      (l) => l.code === +currentLanguageCode 
    );
    setCurrentLanguage(lang);
    loadExerciseData(lang);
  }, []);

  const loadExerciseData = async (currentFilters, customOffset = offset) => {
    try {
      setShowLoading(true);

      const parsedFilters = Object.keys(currentFilters || {}).length> 0 ? currentFilters : { language: currentLanguage?.code };
      const payload = {
        language: parsedFilters?.code ?? parsedFilters.language,
        offset: customOffset,
        limit: rowsPerPage,
      };
      const rs = await api.exercise.listExercises(payload);
      gridRef.current.setSelectionModel([]);
      setLoadedExrcises(rs.data.rows);
      setQuantityRows(rs.data.count);
    } finally {
      setShowLoading(false);
    }
  };

  const handleRowChange = (e) => {
    setCurrentExercise(e?.row);
  };

  const handleOnCloseModalCreateExercise = () => {
    setIsModalCreatePatientVisible(false);
  };

  const handleOnOpenModalCreatexercise = () => {
    setIsModalCreatePatientVisible(true);
  };

  const handleOnCloseModalDetailExercise = () => {
    setIsModalDetailPatientVisible(false);
  };

  const handleOnOpenModalDetailExercise = () => {
    setIsModalDetailPatientVisible(true);
  };

  const handleOnOpenDownloadModal = () => {
    setIsModalDownloadVisible(true);
  };

  const handleOnCloseDownloadModal = () => {
    setIsModalDownloadVisible(false);
    setSelectedDownloadRow(null);
  };

  const renderCustomToolBar = () => {
    return <CustomToolbar />;
  };

  const handleOnDelete = async (data) => {
    try {
      setShowLoading(true);
      await api.exercise.delete(data.id);
      loadExerciseData();
    } finally {
      setShowLoading(false);
      alert(displayMessage("EXERCISE_SUCCESSFULLY_REMOVED"), "success");
    }
  };

  const actionCancel = {
    field: "cancel_action",
    headerName: `${displayMessage("CANCEL")}`,
    width: 95,
    sortable: false,
    align: "center",
    renderCell: (params) => {
      return (
        <div>
          <Popconfirm
            zIndex={10001}
            placement="bottomLeft"
            title={displayMessage("WARNING_REMOVE_EXERCISE")}
            onConfirm={() => handleOnDelete(params.row)}
            okText={displayMessage("YES")}
            cancelText={displayMessage("NO")}
            disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
          >
            <SL_Button
              style={{
                background: "red",
                borderColor: "pink",
                color: "pink",
                fontWeight: "bold",
              }}
              shape="circle"
              icon={<DeleteOutline />}
              disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
            ></SL_Button>
          </Popconfirm>
        </div>
      );
    },
    disableColumnSelector: true,
  };

  const actionDownload = {
    field: "download_action",
    headerName: `${displayMessage("DOWNLOAD")}`,
    width: 100,
    sortable: false,
    align: "center",
    renderCell: (params) => {
      return (
        <div>
          <SL_Button
            onClick={(e) => {
              e.stopPropagation();
              setSelectedDownloadRow(params.row);
              handleOnOpenDownloadModal();
            }}
            style={{
              background: "purple",
              borderColor: "pink",
              color: "pink",
              fontWeight: "bold",
            }}
            shape="circle"
            icon={<DownloadOutlined />}
          />
        </div>
      );
    },
    disableColumnSelector: true,
  };

  return (
    <>
      {isModalCreateExerciseVisible && (
        <CreateExercise
          isModalVisible={isModalCreateExerciseVisible}
          handleOnCloseModal={handleOnCloseModalCreateExercise}
          refreshPatients={loadExerciseData}
        />
      )}

      {isModalDetailExerciseVisible && (
        <DetailExercise
          isModalVisible={isModalDetailExerciseVisible}
          handleOnCloseModal={handleOnCloseModalDetailExercise}
          exercise_id={currentExercise.id}
          refreshExercises={loadExerciseData}
          currentExercise={currentExercise}
        />
      )}

      {isModalDownloadVisible && selectedDownloadRow && (
        <CreateExerciseModal
          currentDownloads={selectedDownloadRow}
          isModalVisible={isModalDownloadVisible}
          handleOnCloseModal={handleOnCloseDownloadModal}
          id={selectedDownloadRow.id}
        />
      )}

      <div className="flex flex-col w-full">
        <div style={{ height: DataGridProHeight, minHeight: 300 }}>
          <div
            className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${
              mobile_mode ? `flex-col` : `flex-row`
            } `}
          >
            <span className="self-center text-white flex-1 text-center font-medium">
              {displayMessage("EXERCISE_LIST")}
            </span>
            <div
              className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`}
            >
              <Select
                className={`w-full flex`}
                placeholder={displayMessage("SELECT_OPTION")}
                value={currentLanguage?.code}
                onChange={(value) => {
                  setCurrentLanguage(Object.values(ELanguages).find(l => l.code === value))
                  loadExerciseData(Object.values(ELanguages).find(l => l.code === value))
              } } 
              >
                {Object.values(ELanguages).map((type) => (
                  <Option value={type?.code}>{type.description}</Option>
                ))}
              </Select>
              <SL_Button
                type="default"
                className="items-center w-30 flex"
                disabled={!currentExercise || currentExercise.deletedAt}
                style={{
                  color: !currentExercise ? "grey" : null,
                  background: !currentExercise ? "lightgrey" : null,
                }}
                onClick={handleOnOpenModalDetailExercise}
                icon={<FileSearchOutlined />}
              >
                {displayMessage("DETAIL_EXERCISE")}
              </SL_Button>
              <SL_Button
                type="default"
                className="items-center w-30 flex"
                onClick={handleOnOpenModalCreatexercise}
                icon={<UserAddOutlined />}
              >
                {displayMessage("CREATE_EXERCISE")}
              </SL_Button>
            </div>
          </div>

          <DataGridPro
            rows={loadedExrcises ?? []}
            apiRef={gridRef}
            style={{ height: "100%" }}
            columns={exercise_grid_columns()
              .concat(actionCancel)
              .concat(actionDownload)}
            density={"comfortable"}
            pageSize={100}
            components={{
              Toolbar: renderCustomToolBar,
              Footer: () => (
                <>
                  <FooterTable
                    offset={offset}
                    rowsPerPage={rowsPerPage}
                    quantityRows={quantityRows}
                    setOffset={setOffset}
                    functionOnChange={(newOffset) =>
                      loadExerciseData(false, newOffset)
                    }
                  />
                </>
              ),
            }}
            onRowClick={handleRowChange}
            disableMultipleSelection
          />
        </div>
      </div>
    </>
  );
}
